import type { DocumentRepository } from "../repositories/document-repository"

export const makeParseDocuments = (repo: DocumentRepository) =>
  (docIds: string[]) =>
    repo.parse(docIds)
